module.exports = __webpack_public_path__ + "static/media/restaurant9.a49f2976.jpg";